var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"56dc9c766de6c11f0a7b36a8880b75dbe5b54087"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yapdomik-frontend-website@sushi-market"]={id:"56dc9c766de6c11f0a7b36a8880b75dbe5b54087"};
      